import { Chip, ChipProps, ComponentVersionsInherit, ComponentVersions_3_0, styled, Tooltip } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

type Props = {
  badge?: 'top-left' | 'top-right'
  size?: ChipProps['size'] | 'xXSmall' | 'xSmall'
  style?: React.CSSProperties
  tooltip?: boolean
  color?: ChipProps['color']
  variant?: ChipProps['variant']
}

const StyledChip = styled(Chip)<Props & { badgeSize: Props['size'] }>(({ badge, badgeSize, style }) => ({
  textTransform: 'uppercase',

  // TODO: move this to an xXSmall Chip size variant
  ...(badgeSize === 'xXSmall' && {
    padding: '0 4px',
    lineHeight: '14px !important',
    minHeight: '14px !important',
    fontSize: 10,
    borderRadius: 3,
  }),

  // TODO: move this to an xSmall Chip size variant
  ...(badgeSize === 'xSmall' && {
    padding: '2px 6px',
    minHeight: '20px !important',
    fontSize: 10,
  }),

  ...(badge === 'top-left' && {
    display: 'block',
    position: 'absolute',
    top: -6,
    left: -6,
  }),
  ...(badge === 'top-right' && {
    display: 'block',
    position: 'absolute',
    top: -6,
    right: -6,
  }),
}))

export const BetaChip = ({ badge, size, style, tooltip, color = 'primary', variant = 'filled' }: Props) => {
  const translate = useTranslate()
  const muiSize: ChipProps['size'] = size === 'xXSmall' || size === 'xSmall' ? 'small' : size
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Tooltip
        title={tooltip === false ? '' : translate('This feature is in beta and may be subject to change.')}
        placement="bottom"
      >
        <StyledChip
          style={style}
          label={translate('Beta')}
          size={muiSize}
          color={color}
          badge={badge}
          badgeSize={size}
          variant={variant}
        />
      </Tooltip>
    </ComponentVersionsInherit>
  )
}
